// @ts-nocheck
import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Message } from './models/Message';

export const MessageSearchCriteria = types.model({
  secretariatId: types.maybeNull(types.number),
  pharmacyId: types.maybeNull(types.number),
});

export const MessageStore = types
  .compose(
    getBaseStore<Instance<typeof Message>, Instance<typeof Message>>(Message, 'messageId', 'message'),
    types.model('MessageStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const updateMessageInStore = (msg: Instance<typeof Message>) => {
      const msgModel = Message.create(msg);
      self.datas.put(msgModel);
      return msgModel;
    };

    const search = flow(function*(criteria: Instance<typeof MessageSearchCriteria>) {
      const result = yield apiFetcher.get('message', {
        params: criteria,
      });
      const resultMsg: Array<Instance<typeof Message>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdMsg = updateMessageInStore(node);
        resultMsg.push(createdMsg);
      });
      return resultMsg;
    });

    const sendMessage = flow(function*(data: any) {
      const res = yield env.api.post('message/Send/withContent', data);
      // @ts-ignore
      updateMessageInStore(res);
    });

    return { search, sendMessage };
  });

export type MessageStoreType = Instance<typeof MessageStore>;
